import React, { memo } from 'react'

import { array, string } from 'prop-types'

import ButtonSelector from './Components/ButtonSelector/ButtonSelector'

function ButtonGroupSelector({ buttons, keyName, sliceName, label }) {
  return (
    <div className="button-group-selector">
      <span className="button-group-selector__label">{label}</span>
      <div className="button-group-selector__buttons">
        {buttons.map((button) => (
          <ButtonSelector
            key={button.id}
            sliceName={sliceName}
            keyName={keyName}
            {...button}
          />
        ))}
      </div>
    </div>
  )
}

ButtonGroupSelector.propTypes = {
  buttons: array.isRequired,
  keyName: string.isRequired,
  sliceName: string.isRequired,
  label: string.isRequired,
}

export default memo(ButtonGroupSelector)
